import { Routes, Route } from 'react-router-dom';

import React from "react";
import {ProfilePage} from "../pages/profile/ProfilePage";

import {ClientePage} from "../pages/cliente/ClientePage";
import {ConfiguracionPage} from "../pages/configuracion/ConfiguracionPage";
import {CompensacionPage} from "../pages/compensacion/CompensacionPage";
import {DeduccionPage} from "../pages/deduccion/DeduccionPage";
import {ContratoPage} from "../pages/contrato/ContratoPage";
import {HomePage} from "../pages/home/HomePage";

import {AsociadoPage} from "../pages/asociado/Asociado";
import {FacturaPage} from "../pages/fatura/FacturaPage";
import {LiquidacionPage} from "../pages/liquidacion/LiquidacionPage";
import {LiquidacionDeduccionPage} from "../pages/liquidacionDeduccion/LiquidacionDeduccionPage";
import {PagoLiquidacionPage} from "../pages/pagoLiquidacion/PagoLiquidacionPage";
import {InformeCompensacionPage} from "../pages/informeCompensacion/InformeCompensacionPage";
import {InformePagosPage} from "../pages/informePago/InformePagosPage";
import {InformeFondosPage} from "../pages/informeFondos/InformeFondosPage";
import {AsociadoDeduccionPage} from "../pages/AsociadoDeduccion/AsociadoDeduccionPage";

import {PagoFondosPage} from "../pages/pagoFondos/PagoFondospage";

import {AsociadoContratoPage} from "../pages/asociadoContrato/AsociadoContratoPage";
import {PensionadoPage} from "../pages/pensionado/PensionadoPage";
import LiquidacioEspecialPage from "../components/SeccionTurnos/LiquidacioEspecialPage";
import TerceroPage from "../pages/tercero/TerceroPage";
import AjusteFondoPage from "../pages/AjusteFondo/AjusteFondonPage";



export const MainRoutes = () => {
    return (
        <>

            <div className="container mx-auto">
                <Routes>
                    <Route  path="/home" element={<HomePage />} />
                    <Route  path="/profile" element={<ProfilePage />} />
                    <Route  path="/afiliados" element={<AsociadoPage />} />
                    <Route  path="/clientes" element={<ClientePage />} />
                    <Route  path="/configuracion" element={<ConfiguracionPage />} />
                    <Route  path="/lista-compensacion" element={<CompensacionPage />} />
                    <Route  path="/lista-deduccion" element={<DeduccionPage />} />
                    <Route  path="/contratos" element={<ContratoPage />} />
                    <Route  path="/facturas" element={<FacturaPage />} />
                    <Route  path="/liquidacion" element={<LiquidacionPage />} />
                    <Route  path="//liquidacion-especial" element={<LiquidacioEspecialPage />} />
                    <Route  path="/liquidar-deducciones" element={<LiquidacionDeduccionPage />} />
                    <Route  path="/pago-liquidacion" element={<PagoLiquidacionPage />} />
                    <Route  path="/informe-compensacion" element={ <InformeCompensacionPage/> } />
                    <Route  path="/informe-pagos" element={ <InformePagosPage/> } />
                    <Route  path="/informe-fondos" element={ <InformeFondosPage/> } />
                    <Route  path="/asociado-deduccion" element={ <AsociadoDeduccionPage/> } />
                    <Route  path="/pago-fondos" element={ <PagoFondosPage /> } />
                    <Route  path="/asociado-contrato" element={ <AsociadoContratoPage/> } />
                    <Route  path="/pensionado" element={ <PensionadoPage/> } />
                    <Route  path="/tercero" element={ <TerceroPage /> } />
                    <Route  path="/ajuste-fondos" element={ <AjusteFondoPage /> } />

                </Routes>
            </div>
        </>
    )
}
